// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import ElementUI from 'element-ui';
import VueAxios from 'vue-axios'
import 'element-ui/lib/theme-chalk/index.css'

import i18n from "../../i18n/i18n";

Vue.config.productionTip = true;
Vue.use(VueAxios, axios);
Vue.use(ElementUI);


/* eslint-disable no-new */
new Vue({
    el: '#app',
    i18n,
    router,
    components: {
        App
    },
    template: '<App/>'
});
